export default __webpack_public_path__ + "static/media/515.5b0c793d.png";